import React from 'react';
import LinkCard from '../shared-components/link_card';
import { connect } from 'react-redux';

// mapStateToProps: pick the Redux state your component needs
const mapStateToProps = (state) => ({
    gameData: state.gameData,
  
    // add other Redux state slices here if needed
});

class ChangeGameChoices extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            prevProcess: this.props.prevProcess,
            allowed: true,
        }    
        this.nextProcess = "";
        this.openProcess = false;
        this.setDisabledStatus();
    }

setDisabledStatus(){
    // check to see if the pendingJob object is empty
    if (+this.props.gameData.jobInfo.nbrSkillSurvey >= 2 || 
        (this.props.gameData.pendingJob  &&
         this.props.gameData.pendingJob.jobStartDate )){ 
            this.skillSurveyOK = false;
    }else{
            this.skillSurveyOK = true;
    }
}

changeSkillSurvey() {
    if (this.skillSurveyOK === true) {
        this.nextProcess = "ChangeSkillSurvey";
        this.openProcess = true;
        this.props.onNavigate("change-skills-survey");
    }
}

changeCareerChoice() {
    this.nextProcess = "ChangeCareer";
    this.openProcess = true;
    this.props.onNavigate("change-career");
}

changeHomeChoice() {
    this.nextProcess = "ChangeHome";
    this.openProcess = true;
    this.props.onNavigate("change-home");
}

changeCarChoice() {
    this.nextProcess = "ChangeCar";
    this.openProcess = true;
    this.props.onNavigate("change-car");
}

closeProcess() {
    this.openProcess = false;
    this.nextProcess = "";
}

  render() {
        this.classSize = "col-sm-8 mt-1"
              
  return <>
           <div className={this.classSize}>
           <div className="card mt-3 mr-2 rounded-corners-lg text-center game-board height-max">
            <h3 className="mt-2 text-center">Change Game Choices</h3>

                  
            <span className="row w-100 mx-0 ml-4">  
                <span className="col-sm-6 mt-4 text-pointer">
                    {this.skillSurveyOK ?
                        <div  onClick={() => this.changeSkillSurvey()}>
                            <LinkCard name="Retake Skills Survey" imgSrc='./assets/GameChoices/change_skills_survey.png'
                                alt=""   allowed={this.skillSurveyOK} destination="" />
                        </div>
                    
                    :
                        <div  className="buttonDisabledImage" onClick={() => this.changeSkillSurvey()}>
                            <LinkCard name="Retake Skills Survey" imgSrc='./assets/GameChoices/change_skills_survey.png'
                              alt=""  allowed={this.skillSurveyOK} destination="" />
                        </div>  
                    }
                    <div onClick={() => this.changeHomeChoice()}>
                        <LinkCard name="Choose a Different Home" imgSrc='./assets/GameChoices/change_home.png' 
                            alt=""  allowed={this.state.allowed} destination=""/>
                                   
                    </div> 
                </span>
                <span className="col-sm-6 mt-4 text-pointer">
                    <div  onClick={() => this.changeCareerChoice()}>
                        <LinkCard name="Choose a Different Job" imgSrc='./assets/GameChoices/change_career.png'
                             alt=""  allowed={this.state.allowed} destination="" />
                    </div>
                    <div onClick={() => this.changeCarChoice()}>
                        <LinkCard name="Choose a Different Car" imgSrc='./assets/GameChoices/change_car.png' 
                             alt=""  allowed={this.state.allowed} destination=""/>
                                  
                    </div> 
                </span>
            </span>
           
        </div>
    </div>   
</>
  }
}

export default connect(mapStateToProps)(ChangeGameChoices);
